import React, { useEffect } from 'react';
import moment from 'moment';
import { fetchInsurancesV2 } from 'slices/insurancesV2';
import { fetchOrganizationInsuranceSectionsV2 } from 'slices/organizationInsuranceSectionsV2';
import { useParams } from 'react-router-dom';
import { useAppDispatch, useTypedSelector } from 'combineReducers';
import { InsuranceExpiredV2 } from 'components/Dashboard/InsuranceExpiredV2';
import { InsuranceExpiringV2 } from 'components/Dashboard/InsuranceExpiringV2';

type RouteParams = {
  organizationId: string;
};

export const InsuranceV2Container: React.FC = () => {
  const dispatch = useAppDispatch();
  const { organizationId } = useParams<RouteParams>();
  const { insurancesV2 } = useTypedSelector(state => state.insurancesV2);
  const { organizationInsuranceSectionsV2 } = useTypedSelector(state => state.organizationInsuranceSectionsV2);

  useEffect(() => {
    if (organizationId) {
      dispatch(fetchInsurancesV2(organizationId));
      dispatch(fetchOrganizationInsuranceSectionsV2(organizationId));
    }
  }, [dispatch, organizationId]);

  const insuranceWithSections = insurancesV2.map(ins => {
    const section = organizationInsuranceSectionsV2.find(section => section.organizationId === ins.organizationId);
    return { ...ins, questionSectionId: section?.sectionId };
  });

  const insuranceExpired = insuranceWithSections.filter(({ earliestPolicyExpirationDateUtc }) =>
    moment(earliestPolicyExpirationDateUtc).isBefore()
  );
  const insuranceExpiring = insuranceWithSections.filter(({ earliestPolicyExpirationDateUtc }) =>
    moment(earliestPolicyExpirationDateUtc).isBetween(moment(), moment().add(30, 'days'))
  );

  return (
    <>
      {insuranceExpired.length > 0 && <InsuranceExpiredV2 insuranceExpired={insuranceExpired} />}
      {insuranceExpiring.length > 0 && <InsuranceExpiringV2 insuranceExpiring={insuranceExpiring} />}
    </>
  );
};
